=== C:\Users\HP\Desktop\sazman\src\views\teacher\EditProfileInfo.vue ===
<template>
  <main id="main" @click="closeAllDropdowns">
    <div v-if="loading" class="d-flex justify-content-center align-items-center" style="height: 100vh;">
      <p>{{ t('loading') }}</p>
    </div>
    
    <div v-else>
        <header class="header_page fadeIn mb-4">
            <p id="title_header_page" class="mr-3 bold">{{ t('edit_profile_info') }}</p>
            <img src="@/assets/imgs/back.svg" class="icon-size-3" alt="" @click="$router.go(-1)">
        </header>

        <div class="p-3 d-flex flex-column align-items-center row-gap-5">
            <div class="d-flex align-items-start justify-content-center">
                <div class="position-relative">
                    <img style="width: 7rem; height: 7rem; object-fit: cover;" :src="profileImageUrl" class="rounded-pill border_theme shadow_input" alt="" @error="$event.target.src = require('@/assets/imgs/NoPath.svg')">
                </div>
            </div>

            <div class="w-100 d-flex align-items-center justify-content-between gap-3">
                <div class="w-50">
                    <label class="pe-3 fadeIn" for="name">{{ t('name') }}</label>
                    <input v-model="form.name" class="p-4 w-100 rounded-pill" id="name" type="text">
                </div>
                <div class="w-50">
                    <label class="pe-3 fadeIn" for="takh">{{ t('family') }}</label>
                    <input v-model="form.family" class="p-4 w-100 rounded-pill" id="takh" type="text">
                </div>
            </div>

            <div class="w-100 d-flex align-items-center justify-content-between gap-3">
                <div class="w-50">
                    <label class="pe-3 fadeIn" for="father_name">{{ t('father_name') }}</label>
                    <input v-model="form.father_name" class="p-4 w-100 rounded-pill" id="father_name" type="text">
                </div>
                <div class="w-50">
                    <label class="pe-3 fadeIn" for="takh_father">{{ t('father_family') }}</label>
                    <input v-model="form.father_family" class="p-4 w-100 rounded-pill" id="takh_father" type="text">
                </div>
            </div>

            <div class="w-100 d-flex align-items-center justify-content-between gap-3">
                <div class="w-50 position-relative z-index-dropdown">
                    <label class="pe-3 fadeIn">{{ t('country') }}</label>
                    
                    <div class="custom-select-box p-4 w-100 rounded-pill d-flex align-items-center justify-content-between cursor-pointer bg-white" 
                        @click.stop="toggleCountryList">
                        <div class="d-flex align-items-center gap-2 overflow-hidden">
                            <img v-if="selectedCountryFlag" :src="selectedCountryFlag" class="flag-icon" alt="">
                            <span class="text-truncate">{{ form.country || t('click_to_select') }}</span>
                        </div>
                        <img src="@/assets/imgs/back.svg" class="rotate-icon" :class="{ 'open': countryListOpen }" style="width: 10px; transform: rotate(-90deg);" alt="">
                    </div>

                    <ul v-if="countryListOpen" class="custom-options-list rounded-4 shadow_box bg-white position-absolute w-100 p-0 m-0 list-unstyled">
                        <li v-for="country in countries" :key="country.id" 
                            class="p-3 border-bottom d-flex align-items-center gap-2 hover-bg"
                            @click.stop="selectCountry(country)">
                            <img :src="country.pic" class="flag-icon" alt="">
                            <span>{{ country.title }}</span>
                        </li>
                    </ul>
                </div>

                <div class="w-50">
                    <label class="pe-3 fadeIn" for="age">{{ t('age') }}</label>
                    <input v-model="form.age" class="p-4 w-100 rounded-pill" id="age" type="number">
                </div>
            </div>

            <div class="w-100 d-flex flex-column align-items-center position-relative z-index-dropdown-low">
                <label class="pe-3 fadeIn w-100 text-start">{{ t('degree') }}</label>
                
                <div class="custom-select-box p-4 w-100 rounded-pill d-flex align-items-center justify-content-start" 
                     style="background-color: #f8f9fa; cursor: default;">
                    <span class="text_color_gray">{{ form.degree || '---' }}</span>
                </div>
            </div>

            <div class="w-100 fadeIn text-center mb-5">
                <label class="pe-3 w-100 text-end mb-2">{{ t('job_docs') }}</label>
                
                <div class="d-flex justify-content-between gap-2">
                    
                    <div class="upload-box" @click="triggerUpload(1)">
                        <div v-if="docs[1].loading" class="spinner-border text-primary" role="status">
                            <span class="visually-hidden">...</span>
                        </div>
                        <div v-else-if="docs[1].name" class="d-flex flex-column align-items-center">
                            <img src="@/assets/imgs/tick.svg" class="icon-size-2" alt="Uploaded">
                            <span class="font_small text-success mt-1">{{ t('exists') }}</span>
                        </div>
                        <div v-else class="d-flex flex-column align-items-center text-color_gray">
                            <span class="font_large bold">+</span>
                        </div>
                    </div>

                    <div class="upload-box" @click="triggerUpload(2)">
                        <div v-if="docs[2].loading" class="spinner-border text-primary" role="status">
                            <span class="visually-hidden">...</span>
                        </div>
                        <div v-else-if="docs[2].name" class="d-flex flex-column align-items-center">
                            <img src="@/assets/imgs/tick.svg" class="icon-size-2" alt="Uploaded">
                            <span class="font_small text-success mt-1">{{ t('exists') }}</span>
                        </div>
                        <div v-else class="d-flex flex-column align-items-center text-color_gray">
                            <span class="font_large bold">+</span>
                        </div>
                    </div>

                    <div class="upload-box" @click="triggerUpload(3)">
                        <div v-if="docs[3].loading" class="spinner-border text-primary" role="status">
                            <span class="visually-hidden">...</span>
                        </div>
                        <div v-else-if="docs[3].name" class="d-flex flex-column align-items-center">
                            <img src="@/assets/imgs/tick.svg" class="icon-size-2" alt="Uploaded">
                            <span class="font_small text-success mt-1">{{ t('exists') }}</span>
                        </div>
                        <div v-else class="d-flex flex-column align-items-center text-color_gray">
                            <span class="font_large bold">+</span>
                        </div>
                    </div>

                </div>

                <input type="file" ref="file1" @change="(e) => handleUpload(e, 1)" accept="image/*" style="display: none;">
                <input type="file" ref="file2" @change="(e) => handleUpload(e, 2)" accept="image/*" style="display: none;">
                <input type="file" ref="file3" @change="(e) => handleUpload(e, 3)" accept="image/*" style="display: none;">
            </div>

            <button class="button" @click="submitEdit" :disabled="submitting || isLoadingAny">
                {{ submitting ? t('loading') : t('submit_post') }}
            </button>
        </div>
    </div>
  </main>
</template>

<script>
import apiClient, { createFormData } from '@/services/api'
import { Decryption } from '@/utils/crypto'

export default {
  name: 'TeacherEditProfileInfo',
  data() {
    return {
      loading: true,
      submitting: false,
      form: {
        name: '',
        family: '',
        father_name: '',
        father_family: '',
        country: '',
        age: '',
        degree: '',
        pic: ''
      },
      docs: {
        1: { name: '', loading: false },
        2: { name: '', loading: false },
        3: { name: '', loading: false }
      },
      profileImageUrl: require('@/assets/imgs/NoPath.svg'),
      countries: [],
      countryListOpen: false
    }
  },
  computed: {
    selectedCountryFlag() {
      if (!this.form.country || !this.countries.length) return null;
      const countryObj = this.countries.find(c => c.title === this.form.country);
      return countryObj ? countryObj.pic : null;
    },
    isLoadingAny() {
        return this.docs[1].loading || this.docs[2].loading || this.docs[3].loading;
    }
  },
  mounted() {
    this.fetchInitialData();
  },
  methods: {
    async fetchInitialData() {
        this.loading = true;
        const userId = localStorage.getItem('user_id');
        try {
            const countryData = createFormData({ action: 'country' });
            const resCountry = await apiClient.post('/public_info', countryData);
            if (Array.isArray(resCountry.data)) {
                this.countries = resCountry.data;
            } else if (resCountry.data.data) {
                const raw = resCountry.data.data;
                this.countries = typeof raw === 'string' ? Decryption(raw) : raw;
            }

            const userData = createFormData({ action: 'teacher_info', user_id: userId });
            const resUser = await apiClient.post('/public_info', userData);
            
            let teacherData = {};
            if (resUser.data) {
                teacherData = resUser.data;
            }

            this.form.name = teacherData.name || '';
            this.form.family = teacherData.family || '';
            this.form.father_name = teacherData.father_name || '';
            this.form.father_family = teacherData.father_family || '';
            this.form.country = teacherData.country || '';
            this.form.age = teacherData.age || '';
            this.form.degree = teacherData.degree || '';
            
            this.form.pic = this.extractFileName(teacherData.profile_pic);
            this.docs[1].name = this.extractFileName(teacherData.pic1);
            this.docs[2].name = this.extractFileName(teacherData.pic2);
            this.docs[3].name = this.extractFileName(teacherData.pic3);

            if (teacherData.profile_pic && teacherData.profile_pic !== 'nopic.png') {
                 this.profileImageUrl = teacherData.profile_pic;
            }

        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            this.loading = false;
        }
    },
    extractFileName(url) {
        if (!url) return '';
        if (!url.includes('/')) return url; 
        const parts = url.split('/');
        return parts[parts.length - 1];
    },
    triggerUpload(index) {
        if (!this.docs[index].loading) {
            this.$refs[`file${index}`].click();
        }
    },
    async handleUpload(event, index) {
        const file = event.target.files[0];
        if (file) {
            this.docs[index].loading = true;
            const fileName = await this.uploadFile(file);
            if (fileName) {
                this.docs[index].name = fileName;
            }
            this.docs[index].loading = false;
        }
    },
    async uploadFile(file) {
      const formData = new FormData();
      formData.append('pic', file);
      formData.append('apikey', '4f3d2a9b7c1e5d6f8a0b9c3d2e4f6a7b');

      try {
        const res = await apiClient.post('/upload_pic', formData);
        if (res.data.status === 'ok') {
          return res.data.pic_name;
        } else {
          this.notify(this.t('upload_error'), 'error');
          return null;
        }
      } catch (e) {
        this.notify(this.t('upload_error'), 'error');
        return null;
      }
    },
    toggleCountryList() {
        this.countryListOpen = !this.countryListOpen;
    },
    selectCountry(country) {
        this.form.country = country.title;
        this.countryListOpen = false;
    },
    closeAllDropdowns() {
        this.countryListOpen = false;
    },
    async submitEdit() {
        this.submitting = true;
        const userId = localStorage.getItem('user_id');

        try {
            const formData = createFormData({
                teacher_id: userId,
                name: this.form.name,
                family: this.form.family,
                father_name: this.form.father_name,
                father_family: this.form.father_family,
                country: this.form.country,
                age: this.form.age,
                degree: this.form.degree,
                pic: this.form.pic,
                pic1: this.docs[1].name,
                pic2: this.docs[2].name,
                pic3: this.docs[3].name,
            });

            const response = await apiClient.post('/teacher/edit_profile', formData);

            if (response.data.status === 'ok') {
                this.notify(response.data.message || this.t('successful_submit'), 'success');
                if(this.form.pic) {
                    const imageBaseUrl = 'https://back.ayendaman.org/storage/app/public/uploads/';
                    localStorage.setItem('temp_profile_pic', imageBaseUrl + this.form.pic);
                }
                this.$router.push({ name: 'TeacherUserArea' });
            } else {
                this.notify(response.data.message || this.t('error_submit'), 'error');
            }
        } catch (error) {
            console.error(error);
            this.notify(this.t('connection_error'), 'error');
        } finally {
            this.submitting = false;
        }
    }
  }
}
</script>

<style scoped>
.rounded_div {
    border-radius: 0 0 5rem 5rem;
    -webkit-box-shadow: 3px 10px 13px -2px rgba(153, 182, 254, 0.68);
    box-shadow: 3px 10px 13px -2px rgba(153, 182, 254, 0.68);
}
.custom-select-box {
    border: 1px solid #e1e1e1;
    transition: all 0.3s ease;
}
.cursor-pointer {
    cursor: pointer;
}
.flag-icon {
    width: 24px;
    height: 24px;
    object-fit: contain;
    border-radius: 50%;
}
.custom-options-list {
    top: 100%;
    left: 0;
    max-height: 200px;
    overflow-y: auto;
    z-index: 100;
    margin-top: 5px !important;
}
.hover-bg {
    transition: background-color 0.2s;
    cursor: pointer;
}
.hover-bg:hover {
    background-color: #f8f9fa;
}
.rotate-icon {
    transition: transform 0.3s ease;
}
.rotate-icon.open {
    transform: rotate(90deg) !important;
}
.z-index-dropdown {
    z-index: 20;
}
.z-index-dropdown-low {
    z-index: 10;
}
.upload-box {
    width: 32%;
    height: 8rem;
    border: 2px dashed #ccc;
    border-radius: 15px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    background-color: #fff;
    transition: all 0.3s;
}
.upload-box:active {
    background-color: #f0f0f0;
    border-color: #4A00E0;
}
.text_color_blue {
    color: #4A00E0;
}
.text_color_gray {
    color: #a0a0a0;
}
</style>